import { useSignal } from '@preact/signals'

import { Button, ComingSoonModal, Typography } from 'components/UI'

import { userInformationState } from '../../../../../state'

const PlanSection = () => {
	const modalContent = useSignal({
		isOpen: false,
		title: '',
		description: ''
	})

	const closeModal = () => {
		modalContent.value = {
			isOpen: false,
			title: '',
			description: ''
		}
	}

	const openModal = () => {
		modalContent.value = {
			isOpen: true,
			title: 'Plans',
			description:
				'Choose the perfect plan to power your dApp development. From basic features to advanced collaboration tools, our upcoming Plans will make it easy to scale and manage your projects. Stay tuned—more details are on the way!'
		}
	}

	return (
		<>
			<ComingSoonModal
				description={modalContent.value.description}
				isModalOpen={modalContent.value.isOpen}
				onCloseModal={closeModal}
				title={modalContent.value.title}
			/>

			<div class='border-t border-solid border-t-black-800 p-5'>
				<Typography
					class='mb-4'
					color='text-gray-400'
					text={`You are under the ${userInformationState.peek()?.subscription.currentPlan.name} Plan.`}
					variant='text3'
				/>
				<Button onClick={openModal} text='Upgrade' variant='secondary' />
			</div>
		</>
	)
}

export { PlanSection }
